// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: tsPH8cIy7v
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicAggBrandInsight.module.css"; // plasmic-import: tsPH8cIy7v/css

createPlasmicElementProxy;

export const PlasmicAggBrandInsight__VariantProps = new Array();

export const PlasmicAggBrandInsight__ArgProps = new Array(
  "brandName",
  "brandAggScore",
  "brandSpecificPage"
);

const $$ = {};

function PlasmicAggBrandInsight__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      aria-describedby={""}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(projectcss.all, projectcss.a, sty.link)}
        href={args.brandSpecificPage}
        platform={"react"}
      >
        <div className={classNames(projectcss.all, sty.freeBox__dvgf2)}>
          <h1
            data-plasmic-name={"brandName"}
            data-plasmic-override={overrides.brandName}
            className={classNames(projectcss.all, projectcss.h1, sty.brandName)}
          >
            {renderPlasmicSlot({
              defaultContents: "Marshalls",
              value: args.brandName,
              className: classNames(sty.slotTargetBrandName)
            })}
          </h1>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__lwrEd)}>
          <div className={classNames(projectcss.all, sty.freeBox__b5OBh)}>
            <div
              data-plasmic-name={"vertical"}
              data-plasmic-override={overrides.vertical}
              className={classNames(projectcss.all, sty.vertical)}
            >
              {renderPlasmicSlot({
                defaultContents: "88",
                value: args.brandAggScore,
                className: classNames(sty.slotTargetBrandAggScore)
              })}
            </div>
            <div
              data-plasmic-name={"hundred"}
              data-plasmic-override={overrides.hundred}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.hundred
              )}
            >
              {" /100"}
            </div>
          </div>
        </div>
      </PlasmicLink__>
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root", "link", "brandName", "vertical", "hundred"],
  link: ["link", "brandName", "vertical", "hundred"],
  brandName: ["brandName"],
  vertical: ["vertical"],
  hundred: ["hundred"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAggBrandInsight__ArgProps,
          internalVariantPropNames: PlasmicAggBrandInsight__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAggBrandInsight__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAggBrandInsight";
  } else {
    func.displayName = `PlasmicAggBrandInsight.${nodeName}`;
  }
  return func;
}

export const PlasmicAggBrandInsight = Object.assign(
  // Top-level PlasmicAggBrandInsight renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    brandName: makeNodeComponent("brandName"),
    vertical: makeNodeComponent("vertical"),
    hundred: makeNodeComponent("hundred"),
    // Metadata about props expected for PlasmicAggBrandInsight
    internalVariantProps: PlasmicAggBrandInsight__VariantProps,
    internalArgProps: PlasmicAggBrandInsight__ArgProps
  }
);

export default PlasmicAggBrandInsight;
/* prettier-ignore-end */
